import React from "react";
import "./ToggleBar.css";

const ToggleBar = ({
  id,
  label,
  description,
  checked = false,
  disabled = false,
  onChange,
  className = "",
}) => {
  const handleChange = (e) => {
    if (disabled) return;
    onChange?.(e.target.checked, e);
  };

  return (
    <label
      className={`toggle-bar${checked ? " is-on" : ""}${disabled ? " is-disabled" : ""}${
        className ? ` ${className}` : ""
      }`}
      htmlFor={id}
    >
      <span className="toggle-bar-switch">
        <input
          id={id}
          type="checkbox"
          role="switch"
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
        />
        <span className="toggle-bar-track">
          <span className="toggle-bar-thumb" />
        </span>
      </span>
      <span>
        <span className="toggle-bar-label">{label}</span>
        {description ? <span className="toggle-bar-desc">{description}</span> : null}
      </span>
    </label>
  );
};

export default ToggleBar;
